import {
  ContentfulRichTextGatsbyReference,
  RenderRichTextData,
} from 'gatsby-source-contentful/rich-text';
import React, { useEffect } from 'react';

import { isBrowser } from '../../../helpers/is-browser';
import { useGetLibraryConstantsDictionary } from '../../../hooks/use-get-library-constants-dictionary';
import { IContentfulImage } from '../../../interfaces/contentful-image.interface';
import { RichText } from '../../rich-text/rich-text';
import Button from '../../ui/button/button';

interface StaticOfferRedemptionProps {
  offerRedemptionDetails?: {
    internalName: string;
    richText: RenderRichTextData<ContentfulRichTextGatsbyReference>;
  };
  handleClose: () => void;
  tenantDetails: {
    offerName?: string;
    tenantName?: string;
    tenantLogo?: IContentfulImage;
  };
  node_locale: string;
}

export const StaticOfferRedemption = ({
  offerRedemptionDetails,
  handleClose,
  tenantDetails,
  node_locale,
}: StaticOfferRedemptionProps) => {
  const dictionary = useGetLibraryConstantsDictionary(node_locale);

  useEffect(() => {
    sendGtmEvent();
  }, []);

  const sendGtmEvent = () => {
    if (isBrowser && dataLayer) {
      dataLayer.push({
        event: 'offer_redemption',
        offer_name: tenantDetails?.offerName,
        offer_redeemed: 'yes',
        offer_redeemed_QR: null,
      });
    }
  };

  return (
    <>
      <div className="card w-[100%] flex flex-col align-centre bg-background-primary rounded-r-[20px] rounded-tl-[20px] p-4 xs:max-h-[50vh] md:max-h-none xs:overflow-y-scroll md:overflow-y-hidden">
        {offerRedemptionDetails && (
          <RichText richText={offerRedemptionDetails?.richText} />
        )}
      </div>
      <div className="button-container flex flex-col gap-4 mt-6">
        <Button variant="primary" onClick={handleClose}>
          {dictionary?.specialOfferClaimedOfferText}
        </Button>
        <Button variant="secondary" onClick={handleClose}>
          {dictionary?.cancelText}
        </Button>
      </div>
    </>
  );
};
